export default defineNuxtRouteMiddleware((to, from) => {
	if (process.client) {
		console.log('Client middleware/check-url-client.ts: to: ', to)
	}
})
